<template>
	<v-container fluid pa-0 ma-0>
	<!-- ----------image slider start------------ -->
		<v-container fluid pa-0 ma-0>
		<v-layout>
		<v-flex xs12>
		<v-carousel  pa-0 ma-0>
			<v-carousel-item
				v-for="(image,i) in images"
				:key="i"
				transition="fade"
				reverse-transition="fade"
			>
			<v-container fluid ma-0 pa-0 fill-height>
				<v-layout row wrap fill-height>
					<v-flex xs12 sm4 fill-height class="hidden-xs-only" style="border-right:1px solid #e1ddd2;">
						<div class="carousel-text pl-4 pr-2 py-3">
							{{image.text}}
						</div>
						<div class="carousel-subtext pl-4 pr-2">
							{{image.subtext}}
						</div>
					</v-flex>
					<v-flex xs12 sm8 fill-height class="text-xs-center carousel-image-wrapper">
						<img :src="image.src" class="carousel-image">
						<div class="carousel-text-xs pa-1 hidden-sm-and-up">
							{{image.text}}
						</div>
					</v-flex>
				</v-layout>
			</v-container>
			</v-carousel-item>
		</v-carousel>
		</v-flex>
		</v-layout>
		</v-container>
	<!-- ----------image slider end------------ -->
		<v-container grid-list-xl fluid px-0 pt-2 pb-0 ma-0 text-xs-center>
			<v-layout row wrap justify-center>
				<v-flex d-flex xs10 sm7 md4>
					<v-card flat color="transparent" class="home-group">
						<img src="img/home/home1.jpg" >
					</v-card>
				</v-flex>
				<v-flex d-flex xs10 sm7 md4 py-0 order-md4>
					<v-card flat color="transparent" class="home-group">
						<h2>
							Facility
						</h2>
					</v-card>
				</v-flex>
				<v-flex d-flex xs10 sm7 md4 order-md7>
					<v-card flat color="transparent" class="home-group">
						<ul>
							<li><router-link to="/cryoem">Cryo-EM</router-link></li>
							<li><router-link to="/leadership">Leadership</router-link></li>
							<li><router-link to="/contactinfo">Contact Info</router-link></li>
						</ul>
					</v-card>
				</v-flex>	
				<v-flex d-flex xs10 sm7 md4>
					<v-card flat color="transparent" class="home-group">
						<img src="img/home/home2.jpg" >
					</v-card>
				</v-flex>
				<v-flex d-flex xs10 sm7 md4 py-0 order-md5>	
					<v-card flat color="transparent" class="home-group">	
						<h2>
							Research
						</h2>
					</v-card>
				</v-flex>	
				<v-flex d-flex xs10 sm7 md4 order-md8>
					<v-card flat color="transparent" class="home-group">
						<ul>
							<li><router-link to="/publications">Publications</router-link></li>
						<!-- example external link 
							<li><a href="http://www.marcottelab.org/">Marcotte Lab</a></li>
						-->
						</ul>
					</v-card>
				</v-flex>	
				<v-flex d-flex xs10 sm7 md4>
					<v-card flat color="transparent" class="home-group">
						<img src="img/home/home3.jpg" >
					</v-card>
				</v-flex>
				<v-flex d-flex xs10 sm7 md4 py-0 order-md6>
					<v-card flat color="transparent" class="home-group">	
						<h2>
							News & Views
						</h2>
					</v-card>
				</v-flex>						
				<v-flex d-flex xs10 sm7 md4 order-md9>
					<v-card flat color="transparent" class="home-group">
						<ul>
							<li><router-link to="/news">Research Spotlights</router-link></li>
						</ul>
					</v-card>
				</v-flex>	
			</v-layout>
		</v-container>
		
		<v-container fluid pa-0 ma-0 class="home-text">
			<h2>Welcome to the Sauer Structural Biology Laboratory!</h2>
			<p>
			The Sauer Structural Biology Laboratory is the state-of-the-art cryo-EM facility. The SSBL
			houses both an FEI Titan Krios equipped with a Gatan K2 Summit direct electron detector and
			an FEI Talos also equipped with a Gatan K2 Summit direct electron detector. Both of these
			instruments are capable of imaging macromolecular machines at atomic or near atomic
			resolution. The facility also contains all of the accessory equipment required for high-resolution
			structure determination. The facility is staffed by a Ph.D. level manager, who has many years of
			experience with electron microscopy.
			</p>
		</v-container>
	</v-container>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      images:[
		{
			src:'./img/home/carousel1.jpg',
			text:'Teaching crystallographers new tricks',
			subtext:'David Taylor and Aguang Dai show Daniel Leahy how to collect cryo-EM data'
		},
		{
			src:'./img/home/carousel2.jpg',
			text:'Studying host-pathogen interactions',
			subtext:'Jason McLellan and his laboratory use structures to answer basic science questions, which can be translated into therapeutics'
		},
		{
			src:'./img/home/carousel3.jpg',
			text:'Forming a polyketide',
			subtext:'Adrian Keatinge-Clay and his laboratory focus on elucidating structures of natural product assembly lines'
		},
		{
			src:'./img/home/carousel4.jpg',
			text:'High-throughput cryo-EM',
			subtext:'David Taylor and his laboratory use electron microsocpy to study multiple structures in a single experiment'
		},
	  ] 
    }
  }
}
</script>

<style scoped>
.grid-main div div{
	padding:20px;
}
.home-group img{
	max-width:100%;
	height:auto;
	border:1px solid #e1ddd2;
}
.home-group h2{
	color: #2d2a28;
	font-size: 30px;
	font-style: normal;
	font-weight: bold;
	margin-top: 0;
	text-align: center;
}
.home-group ul{
    font-size: 20px;
    list-style: none;
    padding: 0 35px 35px;
	text-align:left;
}
.home-group a{
	display: block;
	line-height: 1.2em;
	padding: .2em 0;
	text-decoration: none;
	color: #BF5700;
}
.home-group li a:hover{
	text-decoration: underline;
}
.home-text{
	font-weight:400;
	font-family: "open_sans", sans-serif;
}
.home-text h1{
	font-size:48px;
	margin:36px 0 36px 0;
	font-weight:300;
}
.home-text h2{
	font-size:36px;
	font-weight:600;
	padding:0 20px 0 20px;
}
.home-text p{
	font-size:17.5px;
	margin:25px 0 25px 0;
	padding:0 36px 0 36px;
	text-align: justify;
}
.fade-enter-active,
.fade-leave-active,
.fade-leave-to {
	transition: 1s ease-out;
	position: absolute;
	top: 0;
	left: 0;
}

.fade-enter,
.fade-leave,
.fade-leave-to {
	opacity: 0;
}
.carousel-image-wrapper{
	overflow: hidden;
	position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue